import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class SearchBrandModalForm extends FormBase {
    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getModal(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_BRAND_MODAL}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_CLOSE}"]`, HTMLElement);
    }

    public getFilterInput(root: ParentNode = document): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_FILTER}"]`);
    }

    public getShowAllToggle(root: ParentNode = document): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_SHOW_ALL_TOGGLE}"]`);
    }

    public getPopularRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_POPULAR}"]`, HTMLElement);
    }

    public getAllRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_BRAND_MODAL_ALL}"]`, HTMLElement);
    }
}

const searchBrandModalForm = new SearchBrandModalForm();

export { SearchBrandModalForm, searchBrandModalForm };
